export const featureService = {
  isAllowed: (featureName) => {
    let features = localStorage.getItem("Features");

    if (!features || features === "") return false;

    let featuresArray = features.split(",");

    if (Array.isArray(featureName)) {
      return featureName.some((name) => featuresArray.indexOf(name) >= 0);
    } else {
      return featuresArray.indexOf(featureName) >= 0;
    }
  },
  mapKey: () => {
    return localStorage.getItem("Key");
  },
};

export default featureService;
